<form #authForm="ngForm" (ngSubmit)="submitDomainAuth()" novalidate>

    <div class="flex items-center justify-center dialog-header ">
        Add Domain to Authenticate

        <div class="absolute right-2 flex gap-0 items-center">
            <button type="button" (click)="closeModal()" class="outline-none pl-1 pr-5">
                <i class="pi pi-times"></i>
            </button>
        </div>


    </div>

    <div class="dialog-content">

        <div *ngIf="isAddDomain" class="p-field p-mb-3">
            <label for="domain" class="requiredValue">Domain Name</label>
            <div class="mt-3">
                <input id="domain" type="text" class="w-full" pInputText [(ngModel)]="domain" name="domain" required />
            </div>
        </div>

        <!-- Already Verified Message -->
        <div *ngIf="alreadyVerified" class="text-center py-6">
            <div class="bg-green-50 border-l-4 border-green-500 rounded-lg p-6 mb-4">
                <div class="flex items-center justify-center mb-3">
                    <i class="pi pi-check-circle text-green-600 text-5xl"></i>
                </div>
                <h3 class="text-xl font-semibold text-green-800 mb-2">Domain Already Verified</h3>
                <p class="text-green-700 mb-4">
                    The domain <strong>{{ domain }}</strong> is already verified and active.
                </p>
                <p class="text-gray-600">
                    Please connect a different domain if you need to add another one.
                </p>
            </div>
        </div>

        <!-- Show domain details -->
        <div *ngIf="isShowDetails" class="space-y-6">
            <h2 class="text-2xl font-bold text-gray-800 mb-6">Domain Details</h2>

            <!-- SPF Record -->
            <div *ngIf="spf" class="bg-white rounded-lg shadow-md border border-gray-200">
                <div class="bg-gray-50 px-6 py-4 border-b border-gray-200 rounded-t-lg">
                    <h3 class="text-lg font-semibold text-gray-800 flex items-center">
                        <i class="pi pi-shield text-blue-600 mr-2"></i>
                        SPF Record
                    </h3>
                </div>
                <div class="p-6">
                    <p class="text-gray-600 mb-3">Copy the following SPF record and add it to your DNS settings.</p>
                    <p class="text-sm text-gray-500 mb-4">
                        Steps to set up SPF:
                        <a href="https://www.spf-record.com/" target="_blank"
                            class="text-blue-600 hover:text-blue-800 underline ml-1">
                            Learn More
                        </a>
                    </p>

                    <div class="space-y-4">
                        <div class="flex flex-col">
                            <label class="text-sm font-medium text-gray-700 mb-2">Type</label>
                            <input type="text" pInputText [value]="spf.type" readonly
                                class="w-full p-3 border border-gray-300 rounded-md bg-gray-50 text-gray-600" />
                        </div>

                        <div class="flex flex-col">
                            <label class="text-sm font-medium text-gray-700 mb-2">Host Name</label>
                            <input type="text" pInputText [value]="spf.host" readonly
                                class="w-full p-3 border border-gray-300 rounded-md bg-gray-50 text-gray-600" />
                        </div>

                        <div class="flex flex-col">
                            <label class="text-sm font-medium text-gray-700 mb-2">TXT Record</label>
                            <div class="flex">
                                <input type="text" pInputText [value]="spf.example" readonly
                                    class="flex-1 p-3 border border-gray-300 rounded-l-md bg-gray-50 text-gray-600" />
                                <button pButton type="button" icon="pi pi-copy"
                                    class="p-button-outlined border-l-0 rounded-l-none"
                                    (click)="copyToClipboard(spf.example)" pTooltip="Copy to clipboard">
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <!-- DKIM Records -->
            <div *ngIf="dkim?.length" class="bg-white rounded-lg shadow-md border border-gray-200">
                <div class="bg-gray-50 px-6 py-4 border-b border-gray-200 rounded-t-lg">
                    <h3 class="text-lg font-semibold text-gray-800 flex items-center">
                        <i class="pi pi-key text-green-600 mr-2"></i>
                        DKIM Records
                    </h3>
                </div>
                <div class="p-6">
                    <p class="text-gray-600 mb-3">Copy the following DKIM records and add them to your DNS settings.</p>
                    <p class="text-sm text-gray-500 mb-6">
                        Steps to set up DKIM:
                        <a href="https://globalcyberalliance.org/wp-content/uploads/2025/05/DKIM-Setup-Guide.pdf"
                            target="_blank" class="text-blue-600 hover:text-blue-800 underline ml-1">
                            Learn More
                        </a>
                    </p>

                    <div class="space-y-6">
                        <div *ngFor="let d of dkim; index as i"
                            class="bg-gray-50 rounded-lg p-4 border border-gray-200">
                            <h4 class="text-md font-medium text-gray-800 mb-4 flex items-center">
                                <i class="pi pi-cog text-gray-600 mr-2"></i>
                                DKIM Record {{ i + 1 }}
                            </h4>

                            <div class="space-y-4">
                                <div class="flex flex-col">
                                    <label class="text-sm font-medium text-gray-700 mb-2">Type</label>
                                    <input type="text" pInputText [value]="d.type" readonly
                                        class="w-full p-3 border border-gray-300 rounded-md bg-white text-gray-600" />
                                </div>

                                <div class="flex flex-col">
                                    <label class="text-sm font-medium text-gray-700 mb-2">Host Name {{ i + 1 }}</label>
                                    <div class="flex">
                                        <input type="text" pInputText [value]="d.host" readonly
                                            class="flex-1 p-3 border border-gray-300 rounded-l-md bg-white text-gray-600" />
                                        <button pButton type="button" icon="pi pi-copy"
                                            class="p-button-outlined border-l-0 rounded-l-none"
                                            (click)="copyToClipboard(d.host)" pTooltip="Copy to clipboard">
                                        </button>
                                    </div>
                                </div>

                                <div class="flex flex-col">
                                    <label class="text-sm font-medium text-gray-700 mb-2">Points To (Value)</label>
                                    <div class="flex">
                                        <textarea pInputTextarea [value]="d.value" readonly rows="3"
                                            class="flex-1 p-3 border border-gray-300 rounded-l-md bg-white text-gray-600 resize-none">
                </textarea>
                                        <button pButton type="button" icon="pi pi-copy"
                                            class="p-button-outlined border-l-0 rounded-l-none self-start"
                                            (click)="copyToClipboard(d.value)" pTooltip="Copy to clipboard">
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <!-- Edit SPF & DKIM Tokens -->
        <div *ngIf="isShowEditDetails" class="space-y-6">
            <h2 class="text-2xl font-bold text-gray-800 mb-6">SPF & DKIM Tokens</h2>

            <!-- SPF Token Section -->
            <div class="bg-white rounded-lg shadow-md border border-gray-200">
                <div class="bg-gray-50 px-6 py-4 border-b border-gray-200 rounded-t-lg">
                    <h3 class="text-lg font-semibold text-gray-800 flex items-center">
                        <i class="pi pi-shield text-blue-600 mr-2"></i>
                        SPF Token
                    </h3>
                </div>
                <div class="p-6">
                    <div *ngIf="spf">
                        <p class="text-gray-600 mb-3">Your SPF authentication token for email verification.</p>
                        <p class="text-sm text-gray-500 mb-4">
                            Learn more about SPF:
                            <a href="https://www.spf-record.com/" target="_blank"
                                class="text-blue-600 hover:text-blue-800 underline ml-1">
                                SPF Setup Guide
                            </a>
                        </p>

                        <div class="flex flex-col">
                            <label class="text-sm font-medium text-gray-700 mb-2">SPF Token</label>
                            <div class="flex">
                                <input type="text" pInputText [value]="spf" readonly
                                    class="flex-1 p-3 border border-gray-300 rounded-l-md bg-gray-50 text-gray-600 font-mono text-sm" />
                                <button pButton type="button" icon="pi pi-copy"
                                    class="p-button-outlined border-l-0 rounded-l-none ml-2"
                                    (click)="copyToClipboard(spf)" pTooltip="Copy SPF token">
                                </button>
                            </div>
                        </div>
                    </div>

                    <div *ngIf="!spf" class="text-center py-8">
                        <i class="pi pi-info-circle text-gray-400 text-3xl mb-3"></i>
                        <p class="text-gray-500 italic">No SPF token available</p>
                        <p class="text-sm text-gray-400 mt-2">SPF token will appear here once configured</p>
                    </div>
                </div>
            </div>

            <!-- DKIM Tokens Section -->
            <div class="bg-white rounded-lg shadow-md border border-gray-200">
                <div class="bg-gray-50 px-6 py-4 border-b border-gray-200 rounded-t-lg">
                    <h3 class="text-lg font-semibold text-gray-800 flex items-center">
                        <i class="pi pi-key text-green-600 mr-2"></i>
                        DKIM Tokens
                        <div *ngIf="dkim?.length"
                            class="ml-2 bg-green-100 text-green-800 text-xs px-2 py-1 rounded-full">
                            {{ dkim.length }} {{ dkim.length === 1 ? 'Token' : 'Tokens' }}
                        </div>
                    </h3>
                </div>
                <div class="p-6">
                    <div *ngIf="dkim.length > 0">
                        <p class="text-gray-600 mb-3">Your DKIM authentication tokens for email signing.</p>
                        <p class="text-sm text-gray-500 mb-6">
                            Learn more about DKIM:
                            <a href="https://globalcyberalliance.org/wp-content/uploads/2025/05/DKIM-Setup-Guide.pdf"
                                target="_blank" class="text-blue-600 hover:text-blue-800 underline ml-1">
                                DKIM Setup Guide
                            </a>
                        </p>

                        <div class="space-y-4">
                            <div *ngFor="let token of dkim; index as i"
                                class="bg-gray-50 rounded-lg p-4 border border-gray-200">
                                <div class="flex items-center mb-3">
                                    <i class="pi pi-cog text-gray-600 mr-2"></i>
                                    <div class="text-sm font-medium text-gray-700">DKIM Token {{ i + 1 }}</div>
                                </div>

                                <div class="flex">
                                    <input type="text" pInputText [value]="token" readonly
                                        class="flex-1 p-3 border border-gray-300 rounded-l-md bg-white text-gray-600 font-mono text-sm" />
                                    <button pButton type="button" icon="pi pi-copy"
                                        class="p-button-outlined border-l-0 rounded-l-none ml-2"
                                        (click)="copyToClipboard(token)" pTooltip="Copy DKIM token {{ i + 1 }}">
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div *ngIf="!dkim || dkim.length === 0" class="text-center py-8">
                        <i class="pi pi-info-circle text-gray-400 text-3xl mb-3"></i>
                        <p class="text-gray-500 italic">No DKIM tokens available</p>
                        <p class="text-sm text-gray-400 mt-2">DKIM tokens will appear here once configured</p>
                    </div>
                </div>
            </div>
        </div>

        <div class="flex justify-end mt-4">
            <p-button *ngIf="isAddDomain" type="submit" label="{{!btnLoading ? 'Add Domain' : 'Adding...'}}"
                icon="{{btnLoading ? 'pi pi-spin pi-spinner' : 'pi pi-save'}}" [disabled]="!domain || btnLoading">
            </p-button>

        </div>

    </div>
</form>